import { DecodedTokenTypes } from '../../interfaces/decodedToken'
import { Subscription } from '../../interfaces/subscription'

/** The only two statuses the backend counts as paid up. Mirrors the
 *  `status__in=("active", "trialing")` filter in `HasActiveSubscription`. */
const ACTIVE_STATUSES: Subscription['status'][] = ['active', 'trialing']

export interface LimitedModeInput {
  /** `null` means the organization has no subscription records at all;
   *  `undefined` means the request has not resolved yet. */
  subscription: Subscription | null | undefined
  userType: DecodedTokenTypes['user_type'] | null
}

/**
 * Whether the app should be read-only for this user, mirroring the backend's
 * `HasActiveSubscription` so the two cannot disagree about who is blocked.
 *
 * Deliberately false while the subscription is still loading: a control that
 * starts enabled and then disables is better than the whole panel flickering
 * disabled on every navigation.
 */
export const isLimitedMode = ({
  subscription,
  userType,
}: LimitedModeInput): boolean => {
  // A super administrator is never subject to another organization's billing.
  if (userType === 'SUPER_ADMINISTRATOR') return false

  // No subscription records at all is a legacy organization created before the
  // payment system existed; the backend lets those through untouched.
  if (!subscription) return false

  return !ACTIVE_STATUSES.includes(subscription.status)
}
